import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
const images = [
// Slide 1: Minnesota suburban home in autumn — maples in red/orange/yellow, warm afternoon light
'https://i.imgur.com/5YGDWzZ.jpeg',
// Slide 2: Minnesota suburban home in spring — blooming trees, fresh green grass
'https://i.imgur.com/M72aza8.jpg',
// Slide 3: Minnesota suburban home in summer — mature green maples, blue sky, lush lawn
'https://i.imgur.com/DFRBXIm.jpeg'];
export const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const {
    lang
  } = useLanguage();
  const t = translations[lang].hero;
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const scrollToProperties = () => {
    document.getElementById('properties')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full h-screen overflow-hidden bg-[#1a1a1a]/40" data-id="element-146">
      {/* Background Slideshow */}
      <AnimatePresence mode="sync" data-id="element-147">
        <motion.img key={currentIndex} src={images[currentIndex]} alt="Luxury Real Estate" initial={{
        opacity: 0,
        scale: 1.05
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 1.5,
        ease: 'easeInOut'
      }} className="absolute inset-0 w-full h-full object-cover" data-id="element-148" />
      </AnimatePresence>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/55 z-10" data-id="element-149" />

      {/* Content */}
      <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center px-4" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="flex flex-col items-center" data-id="element-151">
          <span className="eyebrow mb-6" data-id="element-152">{t.eyebrow}</span>
          <h1 className="font-serif-display text-white text-5xl md:text-7xl lg:text-[80px] uppercase tracking-[0.2em] leading-tight mb-4" data-id="element-153">
            {t.headline}
          </h1>
          <p className="body-text text-white/90 uppercase tracking-widest text-sm md:text-base max-w-2xl mb-10" data-id="element-154">
            {t.subhead}
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-155">
            <button onClick={scrollToProperties} className="px-8 py-4 border border-white text-white uppercase tracking-widest text-sm hover:bg-white hover:text-[#1a1a1a] transition-colors duration-300" data-id="element-156">
              {t.buyBtn}
            </button>
            <button onClick={scrollToContact} className="px-8 py-4 bg-[#c9a96e] text-[#1a1a1a] uppercase tracking-widest text-sm hover:bg-[#b5955a] transition-colors duration-300" data-id="element-157">
              {t.sellBtn}
            </button>
          </div>
        </motion.div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-0 right-0 z-20 flex justify-center space-x-3" data-id="element-158">
        {images.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2 h-2 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-[#c9a96e] w-6' : 'bg-white/50 hover:bg-white'}`} aria-label={`Go to slide ${idx + 1}`} data-id="element-159" />)}
      </div>
    </section>;
};